import authStorage from "./actions";
import TypeKeys from "./actionTypes";
import * as actionTypes from "./actionTypes";
import { IAuthState } from "./model";

const authInitialState: IAuthState = {
    ...authStorage,
    isAuthenticating: true,
};

export default function authReducer(state: IAuthState = authInitialState, action: actionTypes.AuthAction): IAuthState {
    switch (action.type) {
        case TypeKeys.DO_AUTHENTICATION:
            return { ...state, isAuthenticating: true };
        case TypeKeys.DO_AUTHENTICATION_SUCCESS:
            return {
                ...state, isAuthenticating: false, profile: action.profile, accessToken: action.accessToken, isLoggedIn: true, expireDate: action.expireDate,
            };
        case TypeKeys.DO_AUTHENTICATION_ERROR:
            return { ...state, isAuthenticating: false, error: action.error };
        case TypeKeys.LOGOUT_SUCCESS:
            return {
                ...state, profile: action.profile, accessToken: action.accessToken, isLoggedIn: false,
            };
        case TypeKeys.RENEW_TOKEN_SUCCESS:
            return { ...state, accessToken: action.accessToken, isLoggedIn: true };
        case TypeKeys.RENEW_TOKEN_ERROR:
            return { ...state, error: action.error };
        default:
            return state;
    }
}
